import {Component, OnInit, Input, Output, ElementRef, Directive} from '@angular/core';
import {
    FormsModule, ReactiveFormsModule, FormControl, FormGroup, Validator, Validators,
    ValidationErrors
} from "@angular/forms";

@Component({
  selector: 'time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.sass']
})
export class TimeInputComponent implements OnInit {

  @Input() time;
  @Output() change_time;

  ctrl;
  constructor() {
  }

  ngOnInit() {

  }

}

@Directive({
    selector: '[time]'
})
export class TimeDirective {

    meridiem:string;
    minute:string;
    hour:string;

    constructor(public el: ElementRef) {

        this.el.nativeElement.onkeypress = (evt) => {
            console.log("evt = " ,evt)
            var curr = evt.target.value;
            var pos = evt.target.selectionEnd;
            var has_selection = evt.target.selectionEnd != evt.target.selectionStart;
            if(has_selection) {
                curr = curr.slice(evt.target.selectionStart,evt.target.selectionEnd - evt.target.selectionStart);
                pos = evt.target.selectionStart;
            }
            console.log("curr = " ,curr)
            console.log("pos = " ,pos)
            var split = curr.split(':');
            console.log("split = " ,split)
            this.hour = split[0] < 12 ? split[0] : 0; // if this equals #
            this.minute = split[1] && split[1].length >= 2 ? split[1].substr(0,2) : (split[1] ? '0'+split[1] : '00');
            var last = split[1] && split[1].length > 2 ? split[1].substr(-2) : '';
            console.log("last = " ,last);
            console.log("this.hour = " ,this.hour);
            console.log("this.minute = " ,this.minute)
            console.log("evt.key = " ,evt.key)
            console.log("evt.target.selectionStart = ",evt.target.selectionStart)
            console.log("evt.target.selectionEnd = ",evt.target.selectionEnd)

            var meridiem_guess = +this.hour > 6 && +this.hour != 12 ? 'am' : 'pm';
            if(!/(a|p)m/.test(last)){
                last = meridiem_guess;
            }
            if(/:/.test(curr))
            this.meridiem = last;

            if(pos <= this.hour.length){
                console.log('hour =[ ',evt.key);
            }
            console.log(this.hour,':',this.minute,this.meridiem);

            if (evt.which == 58 && curr ) {

            }else if(this.hour && [65,77,80,97,109,112].indexOf(evt.which) > -1){

            }else if(evt.which < 48 || evt.which > 57){
                evt.preventDefault();
            }else if(!/:/.test(curr)){
                console.log("this.hour = " ,this.hour);
                var meridiem_guess = +this.hour > 6 && +this.hour != 12 ? 'am' : 'pm';
                if(this.hour === '0' && (evt.key == 1 || evt.key == 2)){
                    this.el.nativeElement.value = this.hour+evt.key+':00'+meridiem_guess;
                    this.el.nativeElement.selectionStart = 3;
                }else if(!this.hour && evt.key > 1 && evt.key < 9){
                    this.el.nativeElement.value = evt.key+':00'+meridiem_guess;
                    setInputSelection(this.el.nativeElement, 2, 4);
                }
                evt.preventDefault();
            }else if(this.minute == '00' && pos == 4){
                this.el.nativeElement.value = this.hour+':'+evt.key+'0'+last;
                setInputSelection(this.el.nativeElement, 3, 4);
                evt.preventDefault();
            }
        };
        function setInputSelection(input, startPos, endPos) {
            if (input.setSelectionRange) {
                input.focus();
                input.setSelectionRange(startPos, endPos);
            } else if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', endPos);
                range.moveStart('character', startPos);
                range.select();
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/time-input/time-input.component.ts